:host {
  display: block;
  max-width: 100%;
  --font-size: var(--body-size);
  --letter-spacing: 0px;
  --font-weight: 400;
  --text-color: var(--body-text-arrows-400);
  --white-space: pre-wrap;
  --overflow-wrap: break-word;
  --line-height: 1.5;
}

.message {
  font-family: var(--font-family);
  font-size: var(--font-size);
  letter-spacing: var(--letter-spacing);
  font-weight: var(--font-weight);
  color: var(--text-color);
  white-space: var(--white-space);
  overflow-wrap: var(--overflow-wrap);
  line-height: var(--line-height);

  &:not(.hide-blinking-cursor):after {
    content: '';
    border-right: 0.05em solid;
    animation: caret 1s steps(1) infinite;
  }

  code {
    color: var(--orange-layout-050-warning);
    border: 1px solid var(--chart-101-pressed-dividers);
    border-radius: 4px;
    padding: 0 calc(var(--spacer) / 2 - 2px);
  }
}

@keyframes caret {
  50% {
    border-color: transparent;
  }
}
